import { getLocalizedText } from "./getLocalizedText"
import type { FaqDto } from "../types"

const DEFAULT_MAX_LENGTH = 140

function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim()
}

/**
 * Card (INFO_CARD/IMAGE_CARD) luôn cần 1 đoạn mô tả để UI cố định chiều cao — nếu
 * meta không khai báo `description`, lấy tạm 1 đoạn từ `rawAnswer` (ưu tiên, đã là
 * text thuần) hoặc `answer` (strip HTML) làm mô tả thay thế.
 */
export function getAnswerExcerpt(faq: FaqDto, locale: string, maxLength: number = DEFAULT_MAX_LENGTH): string {
  const rawText = getLocalizedText(faq.rawAnswer, locale)
  const plainText = rawText || stripHtml(getLocalizedText(faq.answer, locale))

  if (plainText.length <= maxLength) return plainText
  return `${plainText.slice(0, maxLength).trimEnd()}…`
}
